import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Change Impacts by Functional Area',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Functional Area',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Impacts',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Build / Functional',
                                  y: {
                                    '#': {
                                      '@': 'buildFunctional',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      functionalArea:
                                                        'Build / Functional',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Migration',
                                  y: {
                                    '#': {
                                      '@': 'dataMigration',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      functionalArea:
                                                        'Data Migration',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Reporting & Analytics',
                                  y: {
                                    '#': {
                                      '@': 'reportingAndAnalytics',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      functionalArea:
                                                        'Reporting & Analytics',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Change Management',
                                  y: {
                                    '#': {
                                      '@': 'changeManagement',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      functionalArea:
                                                        'Change Management',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Data Integration',
                                  y: {
                                    '#': {
                                      '@': 'dataIntegration',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      functionalArea:
                                                        'Data Integration',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Technical',
                                  y: {
                                    '#': {
                                      '@': 'technical',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      functionalArea:
                                                        'Technical',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Project Management',
                                  y: {
                                    '#': {
                                      '@': 'projectManagement',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      functionalArea:
                                                        'Project Management',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Marketing Cloud',
                                  y: {
                                    '#': {
                                      '@': 'marketingCloud',
                                    },
                                  },
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      functionalArea:
                                                        'Marketing Cloud',
                                                    },
                                                  },
                                                  navigationId:
                                                    'change.impacts',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Functional Area',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar',
        },
      },
    },
  },
  subqueries: {
    technical: {
      filter: {
        '=': [
          {
            '@.': '!functional_area',
          },
          'Technical',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataMigration: {
      filter: {
        '=': [
          {
            '@.': '!functional_area',
          },
          'Data Migration',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    marketingCloud: {
      filter: {
        '=': [
          {
            '@.': '!functional_area',
          },
          'Marketing Cloud',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    buildFunctional: {
      filter: {
        '=': [
          {
            '@.': '!functional_area',
          },
          'Build / Functional',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    dataIntegration: {
      filter: {
        '=': [
          {
            '@.': '!functional_area',
          },
          'Data Integration',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    changeManagement: {
      filter: {
        '=': [
          {
            '@.': '!functional_area',
          },
          'Change Management',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    projectManagement: {
      filter: {
        '=': [
          {
            '@.': '!functional_area',
          },
          'Project Management',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    reportingAndAnalytics: {
      filter: {
        '=': [
          {
            '@.': '!functional_area',
          },
          'Reporting & Analytics',
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
